<label>
  <input
    type="checkbox"
    [checked]="this.checked"
    (change)="change($event)"
    [disabled]="disabled"
  />
  <ng-content></ng-content>
</label>
